import { render, staticRenderFns } from "./AddServiceStudent.vue?vue&type=template&id=41c500ae&scoped=true&"
import script from "./AddServiceStudent.vue?vue&type=script&lang=js&"
export * from "./AddServiceStudent.vue?vue&type=script&lang=js&"
import style0 from "./AddServiceStudent.vue?vue&type=style&index=0&id=41c500ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c500ae",
  null
  
)

export default component.exports